import { defineMessages } from './TypedIntl'

// Foundational shared messages. Hand-picked `shared` namespace (not the
// path-derived default) because these are referenced across every app. Leaf
// keys are unchanged so existing `sharedMessages.x` references keep working;
// the focalazy ids move from `Shared.*` to `shared.*` (see
// packages/localization/focalazy-key-map.json for the old→new mapping the
// history re-import uses).
export const sharedMessages = defineMessages('shared', [
  { id: 'apiError', defaultMessage: 'An error occurred. Please try again.' },
  { id: 'attachmentsTooManyFiles', defaultMessage: 'You can upload a maximum of 20 attachments.' },
  {
    id: 'attachmentsTooLargeFile',
    defaultMessage: 'The file you are trying to upload is too large. Maximum file size is 50 MB.',
  },
  { id: 'metadataRemoved', defaultMessage: 'Metadata has been removed' },
  { id: 'metadataUnableToRemove', defaultMessage: 'Metadata has not been removed' },
  {
    id: 'unsupportedMimetype',
    defaultMessage:
      'We do not support this file type. Please, upload a file in JPG, PNG, PDF, DOC, DOCX, ODT, ODS, XLS, XLSX, TXT, MOV, MP3, MP4, AVI or WAV.',
  },
  { id: 'submit', defaultMessage: 'Send' },
  { id: 'fieldRequired', defaultMessage: 'This field is required' },
  { id: 'selectPlaceholder', defaultMessage: 'Select one' },
  { id: 'encryptionError', defaultMessage: 'Encryption error' },
  { id: 'send', defaultMessage: 'Send' },
  { id: 'delete', defaultMessage: 'Delete' },
  { id: 'download', defaultMessage: 'Download' },
  { id: 'showMore', defaultMessage: 'Show more' },
  { id: 'cancel', defaultMessage: 'Cancel' },
  { id: 'ok', defaultMessage: 'OK' },
  { id: 'bio', defaultMessage: '{name}' },
  { id: 'partnerBio', defaultMessage: '{name}' },
] as const)
